var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgServiceIcon5 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4A4A4A",
  d: "M20 5.36v4.996c0 7.617-7.583 10.574-7.583 10.574L12 21.1l-.417-.17S4 17.973 4 10.356V5.36c0-.36.14-.707.39-.962S4.98 4 5.334 4h13.334c.353 0 .692.143.942.398S20 5 20 5.36"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#service-icon-5_svg__a)",
  d: "M20 10.356V5.36c0-.36-.141-.707-.391-.962A1.32 1.32 0 0 0 18.666 4h-6.25v16.93c1.265-.43 7.583-2.957 7.583-10.574"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m11.062 12.968 4.447-4.81a1.025 1.025 0 1 1 1.505 1.392l-5.386 5.825a.77.77 0 0 1-1.131 0l-2.439-2.637a1.025 1.025 0 1 1 1.505-1.392z",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "service-icon-5_svg__a",
  x1: 13.411,
  x2: 13.411,
  y1: -0.275,
  y2: 22.525,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4EDFC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#568DFE"
})))));
export default SvgServiceIcon5;